// extracted by mini-css-extract-plugin
export var questionBox = "_7x-0";